/**
 * Discover Page Tour Configuration
 * Guided tour for AI Garage tool discovery and exploration
 */

const BASE_STEPS = [
  {
    id: 'welcome',
    title: 'Welcome to AI Garage! 👋',
    description: 'Discover and use AI tools built across RingCentral. Let me show you around in 30 seconds!',
    position: 'center'
  },
  {
    id: 'search',
    title: 'Search & Filter',
    description: 'Search for tools by name or use filters to find tools by role, sales stage, or capability.',
    element: '[data-tour="discover-search"] input',
    position: 'bottom',
    spotlight: true
  },
  {
    id: 'group',
    title: 'Group & Sort Tools',
    description: 'Click here to group tools by sales stage, role, or type.',
    element: '[data-tour="discover-grouping"]',
    position: 'bottom',
    spotlight: true
  },
  {
    id: 'tools',
    title: 'Tool Cards',
    description: 'Each card shows a tool. Use the star to add it to your collection or pin it for quick sidebar access.',
    element: '[data-tour="discover-tools"]',
    position: 'right',
    spotlight: true
  },
  {
    id: 'bookmarks',
    title: 'Your Pinned Tools',
    description: 'Tools you pin appear in the sidebar for quick access.',
    element: '[data-tour="discover-pinned"]',
    position: 'right',
    spotlight: true
  }
];

export const getDiscoverTourSteps = (filterMode) =>
  BASE_STEPS.filter((step) => filterMode === 'advanced' || step.id !== 'group');
